export default "__VITE_ASSET__DBLGTTW3__"